export default __webpack_public_path__ + "static/media/Rubik-Italic.03738d27.ttf";